import { isRentCatalogResponse } from '@/lib/entities/rent/lib/is-rent-catalog-response';
import { isSaleCatalogPageData } from '@/lib/entities/sale/lib/is-sale-catalog-page-data';

type ShouldShowEmptyCatalogSearchResultInput = {
  type: 'rent' | 'sale';
  data: unknown;
  hasQuery: boolean;
};

export const shouldShowEmptyCatalogSearchResult = ({
  type,
  data,
  hasQuery,
}: ShouldShowEmptyCatalogSearchResultInput): boolean => {
  if (!hasQuery) {
    return false;
  }

  if (type === 'sale') {
    return isSaleCatalogPageData(data) && data.saleObjects.length === 0;
  }

  return isRentCatalogResponse(data) && data.rentObjects.length === 0;
};
